import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Toolbar } from '@material-ui/core';
import { HelpWidget } from '../main/HelpWidget';
import { UserProfile } from '../../../models';
import IndividualMenu from './InvidualMenu';
import SettingsIcon from '@material-ui/icons/Settings';
import BusinessIcon from '@material-ui/icons/Business';
import UserIcon from '@material-ui/icons/AccountCircle';
import { PathPattern } from 'src/routing';
import { NotificationWidgetContainer } from '../main/NotificationWidgetContainer';
import GroupIcon from '@material-ui/icons/Group';
import HomeIcon from '@material-ui/icons/Home';
import { useIsSmallScreen } from 'src/helpers/ui';
export interface MenusProps {
  profile: UserProfile;
  siteId?: number;
}

export const Menus = ({ profile, siteId }: MenusProps) => {
  const isSmallScreen = useIsSmallScreen();
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Toolbar disableGutters>
      {siteId && (
        <IconBorder>
          <NotificationWidgetContainer siteId={siteId} />
        </IconBorder>
      )}
      {!isSmallScreen && (
        <IconBorder>
          <HelpWidget />
        </IconBorder>
      )}
      {profile.isSystemAdmin && (
        <IconBorder>
          <IndividualMenu
            Icon={SettingsIcon}
            items={[
              {
                name: 'Companies',
                path: PathPattern.COMPANIES,
                Icon: BusinessIcon,
              },
              {
                name: 'Users',
                path: PathPattern.USERS,
                Icon: GroupIcon,
              },
              {
                name: 'Sites',
                path: PathPattern.SITES,
                Icon: HomeIcon,
              },
            ]}
            title={'System Management'}
          />
        </IconBorder>
      )}

      <IconBorder>
        <IndividualMenu
          Icon={UserIcon}
          items={[
            {
              path: PathPattern.PRIVACY_POLICY,
              name: 'Privacy Policy',
            },
            {
              addBorder: true,
              name: 'Log Out',
              onClick: handleLogout,
            },
          ]}
          title="User"
        />
      </IconBorder>
    </Toolbar>
  );
};

const IconBorder: React.FC = ({ children }) => {
  return (
    <Box alignItems="center" alignSelf="stretch" display="flex" paddingLeft={1}>
      <div>{children}</div>
    </Box>
  );
};
